module.exports = __webpack_public_path__ + "static/media/slovakia.afaba1c1.png";